import * as React from 'react';
import { Field } from 'redux-form';

import { roundUnitValue } from '@acceligentllc/shared/utils/unit';

import type { ConstrainedUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';
import { ConstrainedUnitValueLimits } from '@acceligentllc/shared/enums/quantityUnit';

import type { Sizes } from 'af-fields/Input';
import Input from 'af-fields/Input';

import type { OwnProps as TooltipProps } from 'af-components/Tooltip';

interface OwnProps {
	name: string;
	unit: ConstrainedUnitEnum;
	id?: string;
	label?: string | React.JSX.Element;
	disabled?: boolean;
	onValueChange: (value: string) => void;
	inputSize?: Sizes;
	tooltipMessage?: TooltipProps['message'];
	className?: string;
	disableErrors?: boolean;
	hideErrorText?: boolean;
	forceShowError?: boolean;
	onKeyDown?: (event: Metadata) => void;
	onFocus?: (event: Metadata) => void;
	onBlur?: (event: Metadata) => void;
}

type Props = OwnProps;

const ConstrainedInput: React.FC<Props> = (props) => {

	const {
		label,
		tooltipMessage,
		name,
		disabled,
		unit,
		onFocus,
		onBlur,
		onKeyDown,
		inputSize,
		className,
	} = props;

	const changeValue = (elementUnit: string, value: string) => {
		const { onValueChange } = props;
		onValueChange?.(`${roundUnitValue(+value, elementUnit as ConstrainedUnitEnum)}`);
	};

	const normalizeFieldValue = (min: number, max: number | undefined, elementUnit: string) => {
		return (value: string) => {
			if (value) {
				const normalizedValue = roundUnitValue(+value, elementUnit as ConstrainedUnitEnum);
				if (normalizedValue < min) {
					return min;
				} else if (max !== undefined && normalizedValue > max) {
					return max;
				} else {
					return normalizedValue;
				}
			}
		};
	};

	const renderInput = () => {
		const limits = ConstrainedUnitValueLimits[unit];

		return (
			<Field
				addonAfter={unit}
				className={className}
				component={Input}
				disabled={disabled}
				disableErrors={true}
				hideErrorText={true}
				inputSize={inputSize}
				label={label}
				max={limits.max}
				min={limits.min}
				name={`${name}.${unit}`}
				normalize={normalizeFieldValue(limits.min, limits.max, unit)}
				onBlur={onBlur}
				onFocus={onFocus}
				onKeyDown={onKeyDown}
				onValueChange={changeValue.bind(this, unit)}
				placeholder="0"
				tooltip={tooltipMessage}
				type="number"
			/>
		);
	};

	return (
		<>{renderInput()}</>
	);
};

export default React.memo(ConstrainedInput);
